import type { MeetingsModule } from '@entities/meetings';
import { Section, SectionLabel, ModuleList, ModuleCard, ModuleTitle, ModuleTag } from './styles';

interface ModulesSectionProps {
  modules: MeetingsModule[];
}

export function ModulesSection({ modules }: ModulesSectionProps) {
  if (modules.length === 0) return null;

  return (
    <Section>
      <SectionLabel>Возможности раздела</SectionLabel>
      <ModuleList>
        {modules.map((m) => (
          <ModuleCard key={m.code}>
            <ModuleTitle>{m.title}</ModuleTitle>
            <ModuleTag $active={m.status === 'active'}>
              {m.status === 'active' ? 'работает' : 'скоро'}
            </ModuleTag>
          </ModuleCard>
        ))}
      </ModuleList>
    </Section>
  );
}
